import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const PageWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
  background-color: #f6f6f6;
  font-family: Inter;
  color: #333333;
`;

export const TopBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.75)}`};
  padding: ${() => `${viewSizeCalculator(1)} ${viewSizeCalculator(2)}`};
  background-color: #ffffff;
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;

  svg {
    width: ${() => `${viewSizeCalculator(2.5)}`};
    height: ${() => `${viewSizeCalculator(2.5)}`};
  }
`;

export const TopBarText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopBarTitle = styled.p`
  font-size: ${() => `${viewSizeCalculator(1.125)}`};
  font-weight: 900;
  color: #333333;
`;

export const TopBarSubtitle = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.75)}`};
  font-weight: 500;
  color: #333333;
  opacity: 0.5;
`;

export const Container = styled.div`
  max-width: ${() => `${viewSizeCalculator(56)}`};
  margin: 0 auto;
  padding: ${() => `${viewSizeCalculator(2.5)} ${viewSizeCalculator(2)} ${viewSizeCalculator(4)}`};
`;

export const PageHeading = styled.h1`
  font-size: ${() => `${viewSizeCalculator(2)}`};
  font-weight: 900;
  color: #333333;
  margin-bottom: ${() => `${viewSizeCalculator(0.5)}`};
`;

export const PageSubHeading = styled.p`
  font-size: ${() => `${viewSizeCalculator(0.9375)}`};
  font-weight: 400;
  color: #333333;
  opacity: 0.6;
  margin-bottom: ${() => `${viewSizeCalculator(2.5)}`};
`;

export const ReleaseBlock = styled.div`
  position: relative;
  padding-left: ${() => `${viewSizeCalculator(1.75)}`};
  padding-bottom: ${() => `${viewSizeCalculator(2.5)}`};
  border-left: ${() => `${viewSizeCalculator(0.125)} solid #e4e4e4`};

  &:last-child {
    border-left: ${() => `${viewSizeCalculator(0.125)} solid transparent`};
  }

  &::before {
    content: "";
    position: absolute;
    left: ${() => `-${viewSizeCalculator(0.5)}`};
    top: ${() => `${viewSizeCalculator(0.25)}`};
    width: ${() => `${viewSizeCalculator(0.875)}`};
    height: ${() => `${viewSizeCalculator(0.875)}`};
    border-radius: 50%;
    background-color: #f96c50;
    border: ${() => `${viewSizeCalculator(0.1875)} solid #fff`};
    box-shadow: 0 0 0 ${() => `${viewSizeCalculator(0.125)}`} #f99c89;
  }
`;

export const ReleaseHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.75)}`};
  margin-bottom: ${() => `${viewSizeCalculator(1.25)}`};
  flex-wrap: wrap;
`;

export const ReleaseDate = styled.span`
  font-size: ${() => `${viewSizeCalculator(1.125)}`};
  font-weight: 700;
  color: #333333;
`;

export const VersionTag = styled.span`
  font-size: ${() => `${viewSizeCalculator(0.75)}`};
  font-weight: 700;
  color: #ee3224;
  background-color: #fdecea;
  padding: ${() => `${viewSizeCalculator(0.25)} ${viewSizeCalculator(0.625)}`};
  border-radius: ${() => `${viewSizeCalculator(1)}`};
`;

export const Card = styled.div`
  background-color: #ffffff;
  border: ${() => `${viewSizeCalculator(0.0625)} solid #ebebeb`};
  border-radius: ${() => `${viewSizeCalculator(1)}`};
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333330d;
  padding: ${() => `${viewSizeCalculator(1.25)} ${viewSizeCalculator(1.5)}`};
  margin-bottom: ${() => `${viewSizeCalculator(1)}`};
`;

export const Section = styled.div`
  &:not(:last-child) {
    margin-bottom: ${() => `${viewSizeCalculator(1.25)}`};
    padding-bottom: ${() => `${viewSizeCalculator(1.25)}`};
    border-bottom: ${() => `${viewSizeCalculator(0.0625)} solid #f0f0f0`};
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`};
  margin-bottom: ${() => `${viewSizeCalculator(0.75)}`};
`;

const tagColors = {
  New: { bg: "#e7f6ec", color: "#2e8b57" },
  Improved: { bg: "#eaf1fb", color: "#3b6fd6" },
  Fixed: { bg: "#fdf3e6", color: "#c77b1f" },
};

export const Tag = styled.span`
  font-size: ${() => `${viewSizeCalculator(0.6875)}`};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: ${() => `${viewSizeCalculator(0.1875)} ${viewSizeCalculator(0.5)}`};
  border-radius: ${() => `${viewSizeCalculator(0.5)}`};
  background-color: ${({ type }) => tagColors[type]?.bg || "#f0f0f0"};
  color: ${({ type }) => tagColors[type]?.color || "#333333"};
`;

export const SectionTitle = styled.h3`
  font-size: ${() => `${viewSizeCalculator(0.9375)}`};
  font-weight: 700;
  color: #333333;
`;

export const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${() => `${viewSizeCalculator(0.5)}`};
  padding-left: ${() => `${viewSizeCalculator(0.25)}`};
`;

export const ListItem = styled.li`
  position: relative;
  padding-left: ${() => `${viewSizeCalculator(1)}`};
  font-size: ${() => `${viewSizeCalculator(0.875)}`};
  font-weight: 400;
  line-height: 1.5;
  color: #333333;
  opacity: 0.85;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: ${() => `${viewSizeCalculator(0.45)}`};
    width: ${() => `${viewSizeCalculator(0.375)}`};
    height: ${() => `${viewSizeCalculator(0.375)}`};
    border-radius: 50%;
    background-color: #f96c50;
  }
`;
